import * as React from "react";

import { BlobProvider } from "@react-pdf/renderer";
import * as Filesaver from "file-saver";

export interface Props {
  pdfDocument: JSX.Element;
  title: JSX.Element;
}

const PDFDocument = ({ title, pdfDocument }: Props) => {
  const { useState, useEffect } = React;
  const [ready, setReady] = useState(false);

  // this is hacky but helps set the render to the back of event queue https://github.com/diegomura/react-pdf/issues/420
  useEffect(() => {
    setTimeout(() => {
      setReady(true);
    }, 0);
  }, []);

  const onClickDownload = (ev: React.MouseEvent, blob: Blob) => {
    ev.preventDefault();
    Filesaver.saveAs(blob, "DueDiligenceQuestionnaire.pdf");
  };

  if (!ready) {
    return null;
  } else {
    return (
      <BlobProvider document={pdfDocument}>
        {({ error, blob }) => {
          if (!error) {
            return blob ? (
              <a href="#" onClick={(ev) => onClickDownload(ev, blob)}>
                {title}
              </a>
            ) : (
              title
            );
          } else {
            //console.error(error);
            return null;
          }
        }}
      </BlobProvider>
    );
  }
};

export default PDFDocument;
